import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import '../buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './skip-to-content-plus.scss.js';
import '../buttons/generic-button2.0/index.js';

class SkipToContentPlus extends s {
    constructor() {
        super(...arguments);
        this.label = 'Skip to content';
        this.rtl = false;
    }
    render() {
        return $ `<generic-button-updated type="tertiary" color="purple" styleType="dark" href="#main-content" .label="${this.label}" ?rtl="${this.rtl || isRTL()}"></generic-button-updated>`;
    }
}
SkipToContentPlus.styles = css_248z;
__decorate([
    e({ type: String })
], SkipToContentPlus.prototype, "label", void 0);
__decorate([
    e({ type: Boolean })
], SkipToContentPlus.prototype, "rtl", void 0);
customElements.define('skip-to-content-plus', SkipToContentPlus);

export { SkipToContentPlus };
